import * as React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import WebhooksTable from "../components/Tables/WebhooksTable";
import PageTitles from "../components/Layout/PageTitles";

export default function Webhooks() {
  return (
    <>
      <PageTitles title={"Webhooks"} />
      <Grid id="i" container spacing={3} direction="row">
        <Grid item id="j" xs>
          <Grid item id="k" sx={{ mb: 3 }}>
            <Paper
              id="l"
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "auto",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WebhooksTable />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
